<template>
  <div class="radio-prop">
    <FormItem label="选项样式">
      <RadioGroup v-model="info.form.formType" type="button" button-style="solid">
        <Radio label="">默认</Radio>
        <Radio label="button">按钮</Radio>
      </RadioGroup>
    </FormItem>
  </div>
</template>
<script>
export default {
  name: 'RadioProp',
  props: {
    info: Object,
  },
}
</script>